/**
 * i18next Namespace Constants
 *
 * Centralized definition of all valid i18next namespaces.
 * Used for:
 * - Type generation from database
 * - Admin UI namespace selector
 * - Runtime i18n configuration
 * - TypeScript type safety
 * - Prisma type annotation
 */

/**
 * All valid i18next namespaces
 *
 * Namespaces organize translations by domain/feature:
 * - 'translation': Default namespace for common/shared translations
 * - 'risk': Risk management domain-specific translations
 */
export const I18N_NAMESPACES = ['translation', 'risk'] as const;

/**
 * TypeScript type for valid namespaces
 */
export type I18nNamespace = (typeof I18N_NAMESPACES)[number];

/**
 * Default namespace (used when no namespace specified)
 */
export const I18N_DEFAULT_NAMESPACE: I18nNamespace = 'translation';
